import { X, Trophy, Flame, Clock, Layers } from "lucide-react";
import { useUnit } from "../context/UnitContext";

const PR_LABELS = { poids: "Poids max", reps: "Reps max", volume: "Volume max" };

export const SessionRecap = ({ sets, bloc, jour, onClose }) => {
  const { unit, dw } = useUnit();
  const volume = sets.reduce((a, s) => a + (s.volume || 0), 0);
  const prSets = sets.filter((s) => s.prs?.length > 0);
  const times = sets.map((s) => new Date(s.created_at).getTime()).sort((a, b) => a - b);
  const durationMin = times.length > 1 ? Math.max(1, Math.round((times[times.length - 1] - times[0]) / 60000)) : 0;

  return (
    <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} />
      <div data-testid="session-recap" className="relative w-full max-w-md bg-[#14141A] border border-white/15 p-5 pb-8 sm:pb-5">
        <div className="flex items-start justify-between">
          <div>
            <h2 className="font-display text-4xl text-white leading-none">SÉANCE TERMINÉE</h2>
            <p className="text-[#B0B0B4] text-xs mt-1">Bloc {bloc} · {jour} · aujourd'hui</p>
          </div>
          <button data-testid="recap-close-button" onClick={onClose} className="text-[#B0B0B4] hover:text-white p-2 transition-colors">
            <X size={20} />
          </button>
        </div>
        <div className="grid grid-cols-3 gap-px bg-white/10 border border-[#2E2E3A] mt-4">
          <div className="bg-[#0A0A0A] p-3 text-center">
            <Layers size={16} className="text-[#FF3B30] mx-auto mb-1" />
            <p className="font-display text-2xl text-white">{sets.length}</p>
            <p className="text-[#B0B0B4] text-[10px] uppercase tracking-wider">Séries</p>
          </div>
          <div className="bg-[#0A0A0A] p-3 text-center">
            <Flame size={16} className="text-[#FF3B30] mx-auto mb-1" />
            <p className="font-display text-2xl text-white">{Math.round(dw(volume))}</p>
            <p className="text-[#B0B0B4] text-[10px] uppercase tracking-wider">Volume {unit}</p>
          </div>
          <div className="bg-[#0A0A0A] p-3 text-center">
            <Clock size={16} className="text-[#FF3B30] mx-auto mb-1" />
            <p className="font-display text-2xl text-white">{durationMin}</p>
            <p className="text-[#B0B0B4] text-[10px] uppercase tracking-wider">Minutes</p>
          </div>
        </div>
        <div className="mt-4">
          <h3 className="font-display text-xl text-white flex items-center gap-2">
            RECORDS BATTUS <Trophy size={15} className="text-amber-400" />
          </h3>
          {prSets.length === 0 ? (
            <p className="text-[#B0B0B4] text-sm mt-1">Aucun record aujourd'hui — la prochaine fois !</p>
          ) : (
            <div className="mt-2 divide-y divide-white/5 border border-[#2E2E3A]">
              {prSets.map((s) => (
                <div key={s.id} className="px-3 py-2 flex items-center gap-2 text-sm">
                  <Trophy size={13} className="text-amber-400 shrink-0" />
                  <span className="text-white flex-1 truncate">{s.exercice}</span>
                  <span className="text-[#ccc] font-mono text-xs">{s.poids ? `${dw(s.poids)} ${unit}` : "PDC"} × {s.reps}</span>
                  <span className="text-amber-400/80 text-[10px] uppercase">{s.prs.map((p) => PR_LABELS[p]).join(" · ")}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        <button data-testid="recap-done-button" onClick={onClose}
          className="w-full h-12 mt-5 bg-[#FF3B30] text-white font-display text-2xl tracking-wide hover:bg-[#e0322a] active:scale-[0.98] transition-colors">
          BIEN JOUÉ 💪
        </button>
      </div>
    </div>
  );
};
